import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const toggleWalletPublicAccess = (name) => request.put(`${API_BASE_URL}/blockchain/wallets/${encodeURI(name)}/toggle-public-access`)

export default toggleWalletPublicAccess;